import { logEvent } from "@src/appV2/lib/analytics";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib/analytics/events";
import { type LocationState } from "history";
import pluralize from "pluralize";

import { Button } from "../../components/Button";
import {
  getWorkplacePlacementsPath,
  type WorkplacePlacementsPathSource,
} from "../../Placements/paths";

interface ViewStaffJobsButtonProps {
  workplaceId: string;
  source: WorkplacePlacementsPathSource;
  placementsCount: number;
  placementCandidateId: string | undefined;
  locationState: LocationState;
  variant?: "contained" | "outlined";
}

export function ViewStaffJobsButton(props: ViewStaffJobsButtonProps) {
  const {
    workplaceId,
    source,
    placementsCount,
    placementCandidateId,
    locationState,
    variant = "outlined",
  } = props;

  return (
    <Button
      fullWidth
      variant={variant}
      href={getWorkplacePlacementsPath(workplaceId, source)}
      locationState={locationState}
      sx={(theme) => ({
        // !important is needed to override the default `box-shadow: none` on the button
        boxShadow: `${theme.shadows[3]} !important`,
      })}
      onClick={() => {
        logEvent(APP_V2_APP_EVENTS.PLACEMENT_WORKPLACE_AD_CARD_CLICKED, {
          workplaceId,
          placementCandidateId,
          openJobsCount: placementsCount,
        });
      }}
    >
      View {placementsCount} staff {pluralize("job", placementsCount)}
    </Button>
  );
}
